import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap mb-5" }
const _hoisted_2 = { class: "d-flex ms-auto" }
const _hoisted_3 = { class: "w-140px me-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "All" }, "All", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "Gateway" }, "Gateways", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "Crm" }, "CRMs", -1)
const _hoisted_7 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<button class=\"btn btn-primary btn-sm me-4\" data-bs-toggle=\"tooltip\" title=\"Add API Connection\" id=\"add_api_drawer_toggle\"><span class=\"svg-icon svg-icon-2\"><i class=\"fas fa-plus\"></i></span> Gateway API </button><button class=\"btn btn-primary btn-sm\" data-bs-toggle=\"tooltip\" title=\"Add API Connection\" id=\"add_crm_drawer_toggle\"><span class=\"svg-icon svg-icon-2\"><i class=\"fas fa-plus\"></i></span> CRM API </button>", 2)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "col-12 mt-5" }
const _hoisted_12 = { class: "card h-90" }
const _hoisted_13 = {
  key: 0,
  class: "overlay-layer card-rounded bg-dark bg-opacity-5 align-middle"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "d-flex flex-stack flex-wrap pt-10" }
const _hoisted_18 = { class: "fs-6 fw-bold text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_MerchantApiCard = _resolveComponent("MerchantApiCard")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_AddCrmDrawer = _resolveComponent("AddCrmDrawer")!
  const _component_AddApiDrawer = _resolveComponent("AddApiDrawer")!
  const _component_UpdateApiDrawer = _resolveComponent("UpdateApiDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("select", {
            name: "status",
            "data-control": "select2",
            "data-hide-search": "true",
            class: "form-select form-select-white form-select-sm",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedGroup) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selGroup && _ctx.selGroup(...args)))
          }, _hoisted_7, 544), [
            [_vModelSelect, _ctx.selectedGroup]
          ])
        ]),
        _hoisted_8
      ])
    ]),
    (_ctx.getIsDataEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_alert, {
              title: "Sync Your Data",
              type: "success",
              effect: "light",
              description: "Connect your Gateway and CRM API data",
              "show-icon": ""
            })
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["row g-6 g-xl-9", [_ctx.loading && 'overlay overlay-block']])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apis, (api, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-sm-6 col-xl-6",
              key: index
            }, [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_MerchantApiCard, {
                  "card-classes": "h-90",
                  icon: api.connection.logo_url,
                  endpointDomain: api.connection.domain,
                  connName: api.connection.conn_name,
                  color: "success",
                  arrow: "Up-right",
                  endpointName: api.endpoint_name,
                  aliasName: api.alias_name,
                  endpointStatus: api.endpoint.endpoint_status,
                  "footer-text": "/transactions/query?",
                  indicatorValue: api.connection.category,
                  indicatorLabel: api.endpoint.endpoint_path,
                  isWarning: api.endpoint_status !== 'Active',
                  api: api,
                  apiId: api.id,
                  onEdit: _ctx.editAPI,
                  onRefresh: _ctx.getApis
                }, null, 8, ["icon", "endpointDomain", "connName", "endpointName", "aliasName", "endpointStatus", "indicatorValue", "indicatorLabel", "isWarning", "api", "apiId", "onEdit", "onRefresh"])
              ])
            ]))
          }), 128)),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
            : _createCommentVNode("", true)
        ], 2)),
    (!_ctx.getIsDataEmpty)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, " Showing " + _toDisplayString((_ctx.curPage - 1) * _ctx.rowsPerPage + 1) + " to " + _toDisplayString((_ctx.curPage - 1) * _ctx.rowsPerPage + _ctx.curRows) + " of " + _toDisplayString(_ctx.total) + " entries ", 1),
            _createVNode(_component_el_pagination, {
              "current-page": _ctx.curPage,
              "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.curPage) = $event)),
              onCurrentChange: _ctx.currentPageChange,
              "page-size": _ctx.rowsPerPage,
              layout: "prev, pager, next",
              total: _ctx.total,
              "hide-on-single-page": false,
              background: ""
            }, null, 8, ["current-page", "onCurrentChange", "page-size", "total"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_AddCrmDrawer, { onSubmit: _ctx.onNewCrmSubmit }, null, 8, ["onSubmit"]),
    _createVNode(_component_AddApiDrawer, {
      onSubmit: _ctx.onNewApiSubmit,
      category: "Gateway"
    }, null, 8, ["onSubmit"]),
    _createVNode(_component_UpdateApiDrawer, {
      api: _ctx.selectedApi,
      procs: _ctx.procs,
      onSubmit: _ctx.onUpdateApiSubmit
    }, null, 8, ["api", "procs", "onSubmit"])
  ], 64))
}